/* istanbul ignore file */
export default {
  all: [
  ]
}

